import React from 'react';
import styled, { css } from 'styled-components';
import { GridElem } from '../../../common/grid';
import { ModalContent, ModalOverlay } from '../../../common/modal/elem';
import { Spacing } from '../../../theme';
import { ButtonElem } from '../../../common/button';
import { MarkDown } from '../../../common/markdown/markdown';
import { PopupViewedContainer } from '../../../epic/popup-view';

export interface POPUP_MODAL_DATA {
  id: string;
  body: string;
  linkUrl?: string;
  imgUrl?: string;
}

interface PopupModalProps {
  isOpen: boolean;
  onClose: () => void;
  data: POPUP_MODAL_DATA;
}

export const ModalPopup: React.FC<PopupModalProps> = ({
  data,
  isOpen = false,
  onClose,
}) => {
  return (
    <ModalOverlay>
      <ModalContentStyled open={isOpen}>
        <PopupViewedContainer isIcon onClose={onClose} popupId={data.id} />

        <Container spacing={0}>
          {data.imgUrl && <Img src={data.imgUrl} />}

          <Content>
            <MarkDown tid={data.body} />

            <GridElemStyled isLink={!!data.linkUrl}>
              {data.linkUrl && (
                <ButtonElem
                  type="primary"
                  onClick={() =>
                    window.open(data.linkUrl, '_blank', 'noopener,noreferrer')
                  }
                  tid="POPUP.BUTTON.STUDY"
                />
              )}

              <PopupViewedContainer onClose={onClose} popupId={data.id} />
            </GridElemStyled>
          </Content>
        </Container>
      </ModalContentStyled>
    </ModalOverlay>
  );
};

const ModalContentStyled = styled(ModalContent)<{ open: boolean }>`
  padding: ${Spacing(0)};
  border-radius: 12px;
  max-height: 85%;
  border: 1px solid rgba(244, 225, 135, 0.4);
  box-shadow: 0 0 50px #00000080;
`;

const Container = styled(GridElem)``;

const GridElemStyled = styled(GridElem)<{ isLink: boolean }>`
  gap: ${Spacing(0)};
  ${({ isLink }) =>
    isLink &&
    css`
      gap: ${Spacing(3)};
    `}
`;

const Content = styled.div`
  display: grid;
  padding: ${Spacing(6)} ${Spacing(5)};
  width: 100%;
  gap: ${Spacing(6)};
`;

const Img = styled.img`
  border-radius: 11px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;

  min-height: 200px;
  max-height: 200px;
  object-fit: cover;
  width: 100%;
`;
